var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.panel.panel_widget_id === 1 ? _c("carousel-widget") : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }